import React, { createContext, useState, useContext } from "react";

// Create the context
const Context = createContext();

// Create a provider component
export const ContextProvider = ({ children }) => {
	const [openService, setOpenService] = useState(false);
	const [serviceSlug, setServiceSlug] = useState(null);
	const [progress, setProgress] = useState(0);
	const [disableLoader, setDisableLoader] = useState(false);
	const [loadingStatus, setLoadingStatus] = useState(true);

	return (
		<Context.Provider
			value={{
				serviceStatus: [openService, setOpenService],
				activeService: [serviceSlug, setServiceSlug],
				loadingProgress: [progress, setProgress],
				loadingDisabler: [disableLoader, setDisableLoader],
				preloading: [loadingStatus, setLoadingStatus],
			}}
		>
			{children}
		</Context.Provider>
	);
};

// Create a custom hook for easy access
export const useYTContext = () => useContext(Context);
